import { lazy, Suspense } from 'react';

const CmsAdminPage = lazy(() => import('~/components/admin/cms-admin-page').then((mod) => ({ default: mod.default })));

export default function SettingsPage() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center h-screen">Loading...</div>}>
      <CmsAdminPage />
    </Suspense>
  );
}
